const withBvnPrefix = (value, suffix = "") => {
  const suffixWithTrail = `${suffix}___`;
  return `___BVN__ID__${value}__${suffix ? suffixWithTrail : ""}`;
};
const createBvnInjectionKey = (name) => withBvnPrefix(name);
const carouselInjectionKey = createBvnInjectionKey("carousel");
const tabsInjectionKey = createBvnInjectionKey("tabs");
const progressInjectionKey = createBvnInjectionKey("progress");
const listGroupInjectionKey = createBvnInjectionKey("listGroup");
const avatarGroupInjectionKey = createBvnInjectionKey("avatarGroup");
const accordionInjectionKey = createBvnInjectionKey("accordion");
const checkboxGroupKey = createBvnInjectionKey("checkboxGroup");
const radioGroupKey = createBvnInjectionKey("radioGroup");
const collapseInjectionKey = createBvnInjectionKey("collapse");
const dropdownInjectionKey = createBvnInjectionKey("dropdown");
const navbarInjectionKey = createBvnInjectionKey("navbar");
const rtlPluginKey = createBvnInjectionKey("rtlPlugin");
const breadcrumbPluginKey = createBvnInjectionKey("breadcrumbPlugin");
const modalManagerPluginKey = createBvnInjectionKey("modalManagerPlugin");
const defaultsKey = createBvnInjectionKey("defaults");
const inputGroupKey = createBvnInjectionKey("inputGroup");
const buttonGroupKey = createBvnInjectionKey("buttonGroup");
const toastPluginKey = createBvnInjectionKey("toastPlugin");
const modalControllerPluginKey = createBvnInjectionKey("modalControllerPlugin");
const popoverPluginKey = createBvnInjectionKey("popoverPlugin");
export {
  buttonGroupKey as a,
  breadcrumbPluginKey as b,
  collapseInjectionKey as c,
  defaultsKey as d,
  dropdownInjectionKey as e,
  modalManagerPluginKey as f,
  accordionInjectionKey as g,
  avatarGroupInjectionKey as h,
  inputGroupKey as i,
  checkboxGroupKey as j,
  radioGroupKey as k,
  listGroupInjectionKey as l,
  modalControllerPluginKey as m,
  navbarInjectionKey as n,
  progressInjectionKey as o,
  popoverPluginKey as p,
  tabsInjectionKey as q,
  rtlPluginKey as r,
  carouselInjectionKey as s,
  toastPluginKey as t,
  withBvnPrefix as w
};
//# sourceMappingURL=keys-CFfh7DXf.mjs.map
